import React from 'react'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useAssetsVolumeChart } from '../../Hooks/Features/InventoryDashboard/useAssetsVolumeChart';
import CommonFilterDropdown from '../CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
const AssetsVolumeChart = ({ option, filterValues, setFilterValues }) => {

  const { options, theme, getAssetsVolumnBreakdownSummary } = useAssetsVolumeChart({ option, filterValues, setFilterValues, });

  return (
    <div className='w100 border rounded p-4' style={{
      backgroundColor: theme === "dark" ? "#000" : "#fff", height: "100%"
    }}>
      <div className='d-flex justify-content-between mb-2'>
        <div className='text-black'>
          <h5 style={{ fontSize: "16px", color: theme === "dark" ? "#ffffff" : "#000000" }}>
            Asset Volume Breakdown
          </h5>
          <p style={{ color: theme === "dark" ? "#cccccc" : "#666666", lineHeight: "5px", }}>
            Distribution by selected operational dimension
          </p>
        </div>
        <div className='w10'>
          <CommonFilterDropdown
            fields={[{ key: "assets_volumn_breakdown_options", label: "Asset Type", col: 12, type: "dropdown", showClear: false, onHide: () => { if (filterValues?.isChange) { setFilterValues(prev => ({ ...prev, apiCall: { ...prev.apiCall, volume: true } })) } } }]}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
          />
        </div>
      </div>
      <div style={{ width: '100%', height: '350px' }}>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          containerProps={{
            style: {
              height: "100%"
            }
          }}
        />
      </div>
    </div>
  )
}

export default AssetsVolumeChart
